/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bannerAdminControllerCreateV1 } from '../fn/banner-admin/banner-admin-controller-create-v-1';
import { BannerAdminControllerCreateV1$Params } from '../fn/banner-admin/banner-admin-controller-create-v-1';
import { bannerAdminControllerDeleteV1 } from '../fn/banner-admin/banner-admin-controller-delete-v-1';
import { BannerAdminControllerDeleteV1$Params } from '../fn/banner-admin/banner-admin-controller-delete-v-1';
import { bannerAdminControllerFindAllV1 } from '../fn/banner-admin/banner-admin-controller-find-all-v-1';
import { BannerAdminControllerFindAllV1$Params } from '../fn/banner-admin/banner-admin-controller-find-all-v-1';
import { bannerAdminControllerFindByIdV1 } from '../fn/banner-admin/banner-admin-controller-find-by-id-v-1';
import { BannerAdminControllerFindByIdV1$Params } from '../fn/banner-admin/banner-admin-controller-find-by-id-v-1';
import { bannerAdminControllerReorderV1 } from '../fn/banner-admin/banner-admin-controller-reorder-v-1';
import { BannerAdminControllerReorderV1$Params } from '../fn/banner-admin/banner-admin-controller-reorder-v-1';
import { bannerAdminControllerSearchCursorV1 } from '../fn/banner-admin/banner-admin-controller-search-cursor-v-1';
import { BannerAdminControllerSearchCursorV1$Params } from '../fn/banner-admin/banner-admin-controller-search-cursor-v-1';
import { bannerAdminControllerSearchOffsetV1 } from '../fn/banner-admin/banner-admin-controller-search-offset-v-1';
import { BannerAdminControllerSearchOffsetV1$Params } from '../fn/banner-admin/banner-admin-controller-search-offset-v-1';
import { bannerAdminControllerUpdateV1 } from '../fn/banner-admin/banner-admin-controller-update-v-1';
import { BannerAdminControllerUpdateV1$Params } from '../fn/banner-admin/banner-admin-controller-update-v-1';
import { BannerDto } from '../models/banner-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class BannerAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bannerAdminControllerFindAllV1()` */
  static readonly BannerAdminControllerFindAllV1Path = '/api/v1/banners/admin';

  /**
   * 배너 전체 조회 (관리자).
   *
   * 배너 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerFindAllV1$Response(params?: BannerAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BannerDto>>> {
    const obs = bannerAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 전체 조회 (관리자).
   *
   * 배너 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerFindAllV1(params?: BannerAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<BannerDto>> {
    const resp = this.bannerAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<BannerDto>>): Array<BannerDto> => r.body)
    );
  }

  /** Path part for operation `bannerAdminControllerCreateV1()` */
  static readonly BannerAdminControllerCreateV1Path = '/api/v1/banners/admin';

  /**
   * 배너 생성.
   *
   * 배너을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerAdminControllerCreateV1$Response(params: BannerAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    const obs = bannerAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 생성.
   *
   * 배너을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerAdminControllerCreateV1(params: BannerAdminControllerCreateV1$Params, context?: HttpContext): Observable<BannerDto> {
    const resp = this.bannerAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerAdminControllerSearchOffsetV1()` */
  static readonly BannerAdminControllerSearchOffsetV1Path = '/api/v1/banners/admin/search/offset';

  /**
   * 배너 오프셋 기반 조회 (관리자).
   *
   * 배너을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerAdminControllerSearchOffsetV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerSearchOffsetV1$Response(params: BannerAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<BannerDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = bannerAdminControllerSearchOffsetV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 오프셋 기반 조회 (관리자).
   *
   * 배너을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerAdminControllerSearchOffsetV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerSearchOffsetV1(params: BannerAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<{
'items': Array<BannerDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.bannerAdminControllerSearchOffsetV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<BannerDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<BannerDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `bannerAdminControllerSearchCursorV1()` */
  static readonly BannerAdminControllerSearchCursorV1Path = '/api/v1/banners/admin/search/cursor';

  /**
   * 배너 커서 기반 조회 (관리자).
   *
   * 배너을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerAdminControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerSearchCursorV1$Response(params: BannerAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<BannerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = bannerAdminControllerSearchCursorV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 커서 기반 조회 (관리자).
   *
   * 배너을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerAdminControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerSearchCursorV1(params: BannerAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<{
'items': Array<BannerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.bannerAdminControllerSearchCursorV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<BannerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<BannerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `bannerAdminControllerFindByIdV1()` */
  static readonly BannerAdminControllerFindByIdV1Path = '/api/v1/banners/admin/{id}';

  /**
   * 배너 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerFindByIdV1$Response(params: BannerAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    const obs = bannerAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerFindByIdV1(params: BannerAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<BannerDto> {
    const resp = this.bannerAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerAdminControllerDeleteV1()` */
  static readonly BannerAdminControllerDeleteV1Path = '/api/v1/banners/admin/{id}';

  /**
   * 배너 삭제.
   *
   * 배너을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerDeleteV1$Response(params: BannerAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    const obs = bannerAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 삭제.
   *
   * 배너을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bannerAdminControllerDeleteV1(params: BannerAdminControllerDeleteV1$Params, context?: HttpContext): Observable<BannerDto> {
    const resp = this.bannerAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerAdminControllerUpdateV1()` */
  static readonly BannerAdminControllerUpdateV1Path = '/api/v1/banners/admin/{id}';

  /**
   * 배너 수정.
   *
   * 배너을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerAdminControllerUpdateV1$Response(params: BannerAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
    const obs = bannerAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 수정.
   *
   * 배너을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerAdminControllerUpdateV1(params: BannerAdminControllerUpdateV1$Params, context?: HttpContext): Observable<BannerDto> {
    const resp = this.bannerAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BannerDto>): BannerDto => r.body)
    );
  }

  /** Path part for operation `bannerAdminControllerReorderV1()` */
  static readonly BannerAdminControllerReorderV1Path = '/api/v1/banners/admin/reorder';

  /**
   * 배너 순서 변경.
   *
   * 배너의 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bannerAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerAdminControllerReorderV1$Response(params: BannerAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = bannerAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 배너 순서 변경.
   *
   * 배너의 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bannerAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bannerAdminControllerReorderV1(params: BannerAdminControllerReorderV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.bannerAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
